<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed">
        <div class="w-100">
          <cm-messages-filter
            v-if="serviceId === services.PAYMENTS && mode === 2"
            class="researchfilter position-relative z-10"
            isPayments received
            filterType="group"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()">
          </cm-messages-filter>
          <cm-messages-filter
            v-else
            class="researchfilter position-relative z-10"
            isPayments received
            filterType="list"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage ml-3 mr-3" style="/* overflow:hidden;*/">
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  v-if="serviceId === services.PAYMENTS && mode === 2"
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="group"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV(inboxMessages)"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
                <cm-messages-filter
                  v-else
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV(inboxMessages)"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
              </div>
            </div>

            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <span v-if="items.length" class="font-weight-bold">{{ $t('common.results_payments_desc') +  paginationObject.nbResultsTotal}}</span>
              <b-table hover fixed responsive ref="tableRTP"
                v-if="mode === 1 && items.length" selectable
                class="mt-3 table-condensed sm-mt-3 hide-column table-striped"
                :key="keyTableRTP"
                :items="items"
                :fields="fields"
                select-mode="single"
                empty-text="Pas de résultats..."
                @row-selected="seeDetails">
                <template #cell(amnt)="data">
                  <div v-if="data.value.includes('+')" class="cursor text-success font-weight-bold">{{ data.value }}</div>
                  <div v-else class="cursor text-danger font-weight-bold">{{ data.value }}</div>
                </template>
                <template #cell(direction)="data">
                  <div class="cursor">
                    <span v-if="data.value === 0" class="direction-received">{{$t('common.rcvd')}}</span>
                    <span v-else class="direction-sent">{{$t('common.snt')}}</span>
                    <i class="fa-duotone fa-warning text-warning" v-if="data.item.exec_date_warning" :title="$t('common.exec_date_exprd')"></i>
                    <i class="fa fa-xmark color-red" v-else-if="data.item.technicalCode === '2'"></i>
                    <i class="fa-solid fa-plug-circle-xmark redIcon" v-else-if="data.item.technicalCode === '3'"></i>
                  </div></template>
                <template #cell(rsn)="data"><div class="cursor text-ellipsis"><span :title="data.value">{{data.value}}</span></div></template>
                <template #cell(status_label)="data">
                  <div v-if="data.item.standard === '2' && data.value === 'rtp.20'" class="cursor">{{ $t('common.status.rtp.10')}}</div>
                  <div v-else class="cursor">{{ $t('common.status.' + data.value) }}</div>
                </template>
                <template #cell(debtor_name)="data"><div class="cursor text-ellipsis"><span :title="data.value">{{data.value}}</span></div></template>
                <template #cell(debtor_iban)="data"><div class="cursor text-ellipsis"><span :title="data.value">{{data.value}}</span></div></template>
                <template #cell(create_date)="data"><div class="cursor text-ellipsis">{{data.value | formatDateTime}}</div></template>
                <template #cell(exp_date)="data"><div class="cursor text-ellipsis">{{data.value | formatDateTime}}</div></template>
              </b-table>

              <b-table hover fixed responsive
                v-if="true/*mode === 2 && items_grp.length*/"
                class="mt-3 sm-mt-3"
                :key="keyTableGroupRTP"
                :items="items_grp"
                :fields="fields_grp"
                selectable select-mode="single" @row-selected="seeDetails_grp">
              </b-table>

              <label class="font-bold w-100 d-flex justify-content-center mt-3" v-if="items.length <= 0">{{ $t('common.no_result') }}</label>
            </div>
            <b-row class="mt-5">
              <b-col>
                <b-col cols="12">
                  <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'
import Pagination from '@/components/common/pagination.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import services from '@/helpers/services'
import {statusLabel} from '@/helpers/labels'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import FormWriteGroupLabelInput from '../../components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'RTPList',
  components: {
    'cm-messages-filter': MessagesFilter,
    'form-write-group-label-input': FormWriteGroupLabelInput,
    'spinner': Spinner,
    'page-outline': PageOutline,
    'cm-pagination': Pagination
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    /* DRO : Enlever le div utilisant cette fonction car dégrade l'espacement entre les boutons et le tableau
    customMobileLayoutStyle () {
      if (this.serviceId === services.PAYMENTS) {
        return 'height:136px;'
      } else {
        return 'height:90px;'
      }
    },*/
    canSeeSRTP () {
      return this.$engine.rights.rightIs('rtp_norm_srtp', true)
    },
    canSeeHRTP () {
      return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
    },
    fields () {
      return [
        { key: 'direction', label: this.$t('common.origin'), class: 'text-center' },
        { key: 'rsn', label: this.$t('common.rsn'), class: 'text-center'},
        { key: 'status_label', label: this.$t('common.status.status_label'), class: 'text-center' },
        { key: 'amnt', label: this.$t('common.amnt'), class: 'text-center' },
        { key: 'debtor_name', label: this.$t('filter.cntct_name'), class: 'text-center' },
        { key: 'debtor_iban', label: this.$t('common.debtor_ibn'), class: 'text-center' },
        { key: 'create_date', label: this.$t('common.trtmnt_date'), class: 'text-center' },
        { key: 'exp_date', label: this.$t('common.date_expr'), class: 'text-center' }
      ]
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      let fromServiceIdToLabel = {
        1: {
          '1': this.$t('Webheader.my_claims_list'),
        },
        2: {
          '1': this.$t('Webheader.my_claims_folders')
        }
      }
      return fromServiceIdToLabel[this.mode][this.$engine.user.currentService.id]
    }
  },
  data () {
    return {
      activateSpinner: false,
      activateSpinnerGroup: false,
      filterBy: '',
      filterConditions: {},
      fields_grp: [
        { key: 'rsn_grp', label: this.$t('common.rsn'), class: 'text-center' },
        { key: 'status_label_grp', label: this.$t('common.status.status_label'), class: 'text-center' },
        { key: 'amnt_grp', label: this.$t('common.amnt'), class: 'text-center' },
        { key: 'dir_pymnts_grp', label: this.$t('servicesNames.dir_pymnts'), class: 'text-center' },
        { key: 'exec_date_grp', label: this.$t('common.exec_date'), class: 'text-center' }
      ],
      icon: 'help',
      inboxMessages: [],
      items: [],
      items_grp: [],
      keyTableGroupRTP: false,
      keyTableRTP: false,
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      payments: undefined,
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t('common.appname'),
      services: services,
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.listTitle,
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: this.direction})
    this.$engine.services.payments.currentSendbox = {}

    this.$bus.$off('refresh-cache-contacts')
    if (this.serviceId === services.PAYMENTS) {
      this.paginationObject['refresh'] = 'inbox-filtered'
      this.$bus.$off('inbox-filtered')
      this.$bus.$off('refresh-inbox-on-seen')
      this.$bus.on('refresh-inbox-on-seen', (refPays) => {
        that.updateInbox(refPays, true)
        loadPage(that, {url: '/payments/transaction-details/'})
      })
      this.$bus.$on('inbox-filtered', index => {
        that.onRefresh(false, index)
        that.pageCounter = 0
      })
    }

    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: 'direction', label: that.$t('common.origin'), class: 'text-center' },
        { key: 'rsn', label: that.$t('common.rsn'), class: 'text-center' },
        { key: 'status_label', label: that.$t('common.status.status_label'), class: 'text-center' },
        { key: 'amnt', label: that.$t('common.amnt'), class: 'text-center' },
        { key: 'debtor_name', label: that.$t('filter.cntct_name'), class: 'text-center' },
        { key: 'debtor_iban', label: this.$t('common.my_ibn'), class: 'text-center' },
        { key: 'create_date', label: that.$t('common.trtmnt_date'), class: 'text-center' },
        { key: 'exp_date', label: that.$t('common.date_expr'), class: 'text-center' }
      ]
      that.updateItems(that.payments)
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
  },
  beforeDestroy () {
    let that = this
    that.$engine.services.payments.filter.cleanFilterCondition()
    this.$bus.$off('language-changed')
  },
  methods: {
    applyFilter (filterConditions) {
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }
      this.filterConditions = filterConditions
      //console.log('filterConditions', filterConditions)
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      if (this.mode === 2) {
        if (this.serviceId === services.PAYMENTS) {
          this.activateSpinnerGroup = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          this.getRTPGroup(filterConditions)
        }
      } else {
        this.activateSpinner = true
        let that = this
        if (this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '1'
        } else if (!this.canSeeSRTP && this.canSeeHRTP) {
          filterConditions.standard = '2'
        } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '0'
        }
        this.$engine.services.payments.update(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          if (that._isDestroyed) {
            return
          }
          let requests = {}
          that.paginationObject.nbResultsTotal = resp.data.totalPayments
          that.paginationObject.nbResults = resp.data.payments.length
          that.payments = resp.data.payments
          that.updateItems(that.payments)
          that.updateInbox(that.payments)
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
          that.activateSpinner = false
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    attachInfinit () {
      if ((this.$settings.inboxPreloaderRemoved && this.serviceId === services.PAYMENTS) ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        if (this.serviceId === services.PAYMENTS) {
          this.$engine.settings.set({inboxPreloaderRemoved: false})
        } else {
          this.$engine.settings.set({sendboxPreloaderRemoved: false})
        }
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      if (this.serviceId === services.PAYMENTS) {
        this.$engine.settings.set({inboxPreloaderRemoved: true})
      } else {
        this.$engine.settings.set({sendboxPreloaderRemoved: true})
      }
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV (inboxMessages) {
      let firstLine = ''
      if(this.mode === 1) {
        firstLine =
        this.$t('common.origin') + ';' +
        this.$t('filter.msgId') + ';' +
        this.$t('common.endtoendid_label') + ';' +
        // this.$t('common.invc_ref') + ';' +
        this.$t('common.rsn') + ';' +
        this.$t('common.date_recpt') + ';' +
        // date reception to add
        this.$t('common.trtmnt_date') + ';' +
        this.$t('common.date_expr') + ';' +
        // QR Code to add
        // reason to chance to add
        // this.$t('common.rsn_new') + ';' +
        this.$t('common.amnt') + ';' +
        this.$t('common.crcy') + ';' +
        // amount to change
        // this.$t('common.amnt_new') + ';' +
        this.$t('filter.cntct_name') + ';' +
        this.$t('common.crdt_agnt') + ';' +
        // ultimate creditor to add
        this.$t('common.crdt_ibn') + ';' +
        this.$t('common.debtor_ibn_used') + ';' +
        this.$t('common.debtor_name_long') + ';' +
        this.$t('common.status.status_label') + ';' +
        ' \r\n'
      } else if (this.mode === 2) {
        firstLine = this.$t('common.rsn') + ';' +
        this.$t('common.status.status_label') + ';' + this.$t('common.total_amount_no_currency') + ';' +
        this.$t('servicesNames.dir_pymnts') + ';' +
        this.$t('common.date_label') + ' \r\n'
      }
      let lines = ''
      const that = this

      // this.scrollFlag = true
      if (this.mode === 2) {
      } else {
        let that = this
        this.paginationObject['firstIndex'] = 1
        let filterConditions
        if (this.filterConditions) {
          filterConditions = this.filterConditions
        } else if (Object.keys(this.$engine.services.payments.filter.getDefaultFilter()).length > 0) {
          filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
        } else {
          filterConditions = this.$engine.services.payments.filter.getConditionObject()
        }
        if (this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '1'
        } else if (!this.canSeeSRTP && this.canSeeHRTP) {
          filterConditions.standard = '2'
        } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '0'
        }
        this.$engine.services.payments.update(
          this.direction,
          this.paginationObject.nbResultsTotal,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let inboxMessagesCSV = {}
          inboxMessagesCSV = resp.data.payments

          if (that.serviceId === services.DOCUMENTSERVICE) {
            for (let datas in inboxMessagesCSV) {
              lines += statusLabel(that.$i18n, 'Folder_' + inboxMessagesCSV[datas]['status']) + ';' +
              inboxMessagesCSV[datas]['reference'] + ';' +
              inboxMessagesCSV[datas]['nb_docs_to_process'] + ';' +
              inboxMessagesCSV[datas]['nb_docs_total'] + ';' +
              inboxMessagesCSV[datas]['correspondent'] + ';' +
              that.$engine.user.get().identifier + '\r\n'
            }
          } else {
            for (let datas in inboxMessagesCSV) {
              let origin = inboxMessagesCSV[datas].direction === '1' ? that.$i18n.t('common.snt') : that.$i18n.t('common.rcvd')
              let msgId = inboxMessagesCSV[datas].msgId
              let endToEndId = inboxMessagesCSV[datas].endToEndId
              // let invoiceRef = inboxMessagesCSV[datas].endToEndId
              let reason = inboxMessagesCSV[datas].reason
              let receptionDate = moment(inboxMessagesCSV[datas].dateTime).format(that.$i18n.t('common.datepicker_format_date') + 'hh:mm:ss')
              let trtmnt_date = ''
              if (inboxMessagesCSV[datas].acceptedRequestedExecutionDatetime) {
                trtmnt_date = inboxMessagesCSV[datas].acceptedRequestedExecutionDatetime
              } else if (inboxMessagesCSV[datas].requestedExecutionDate) {
                trtmnt_date = inboxMessagesCSV[datas].requestedExecutionDate
              }
              trtmnt_date = moment(trtmnt_date).format(that.$i18n.t('common.datepicker_format_date') + 'hh:mm:ss')
              let exp_date = ''
              if(inboxMessagesCSV[datas].requestedExpirationDate) {
                exp_date = inboxMessagesCSV[datas].requestedExpirationDate
                exp_date = moment(exp_date).format(that.$i18n.t('common.datepicker_format_date') + 'hh:mm:ss')
              }
              let newReason = ''
              let amnt = ''
              if (inboxMessagesCSV[datas].creditNoteAmount) {
                amnt += parseFloat(inboxMessagesCSV[datas].creditNoteAmount).toFixed(2).toString()
              } else {
                if (inboxMessagesCSV[datas].amountResponse) {
                  amnt += parseFloat(inboxMessagesCSV[datas].amountResponse).toFixed(2).toString()
                } else if (inboxMessagesCSV[datas].Amount) {
                  amnt += parseFloat(inboxMessagesCSV[datas].Amount.replace('-', '')).toFixed(2).toString()
                } else {
                  amnt += parseFloat(inboxMessagesCSV[datas].amount).toFixed(2).toString()
                }
              }
              let currency = inboxMessagesCSV[datas].currency
              // let amountToChange
              // let newAmount

              let correspondant_name = ''
              if (inboxMessagesCSV[datas].debtorName === undefined || inboxMessagesCSV[datas].debtorName === '') {
                correspondant_name = '-'
              } else if (inboxMessagesCSV[datas].direction === '1') {
                correspondant_name = inboxMessagesCSV[datas].debtorName
              } else {
                correspondant_name = inboxMessagesCSV[datas].creditorName
              }
              let creditorAgent = inboxMessagesCSV[datas].creditorBIC
              // let ultimateCreditor
              let creditor_iban = inboxMessagesCSV[datas].creditorBankAccount
              let debtor_iban = inboxMessagesCSV[datas].debtorBankAccount
              let debtor_name = inboxMessagesCSV[datas].debtorName
              let statusTrad = 'common.status.rtp.' + inboxMessagesCSV[datas].status
              let status = that.$i18n.t(statusTrad) === statusTrad ? that.$i18n.t('common.status.unknown') : that.$i18n.t('common.status.rtp.' + inboxMessagesCSV[datas].status)



              lines += origin + ';' +
              msgId + ';' +
              endToEndId + ';' +
              reason + ';' +
              receptionDate + ';' +
              trtmnt_date + ';' +
              exp_date + ';' +
              amnt + ';' +
              currency + ';' +
              correspondant_name + ';' +
              creditorAgent + ';' +
              creditor_iban + ';' +
              debtor_iban + ';' +
              debtor_name + ';' +
              status + '\r\n'
            }
          }

          let data = firstLine + lines
          that.$f7.hidePreloader()
          // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
          let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
          let linkSource = URL.createObjectURL(encodedData);
          const downloadLink = document.createElement('a')
          let today = moment()
          const fileName = that.listTitle + '_' + today.unix() + '.csv'
          if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
          ) {
            downloadFileWithDefinedHeaders(this, fileName, linkSource)
          } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
          }
          this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    getRTPGroup (filterConditions = {}) {
      let that = this
      this.$engine.services.payments.getGroups(filterConditions).then(response => {
        let groups = response.data.groups
        this.paginationObject.nbResultsTotal = groups.length
        this.updateItems_grp(groups)
        this.updateInbox(groups)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.$f7.hideIndicator()
        this.activateSpinnerGroup = false
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        this.activateSpinnerGroup = false
        errorMessageAlert(error, that)
      })
    },
    goBack (url) {
      if (url !== 'none') {
        loadPage(this, {url: url})
      } else {
        /* On évite d'afficher la page de login a un utilisateur deja connecte */
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          this.$bus.$emit('router-back')
          this.$f7.mainView.router.back()
        }
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0
        if (this.mode === 2) {
          if (this.serviceId === services.PAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services.payments.filterGroup.getDefaultFilter()) {
              filterConditions = this.$engine.services.payments.filterGroup.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services.payments.filterGroup.getConditionObject()
            }
          }
        } else {
          let filterConditions
          if (this.$engine.services.payments.filter.getDefaultFilter()) {
            filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services.payments.filter.getConditionObject()
          }
          if (this.canSeeSRTP && !this.canSeeHRTP) {
            filterConditions.standard = '1'
          } else if (!this.canSeeSRTP && this.canSeeHRTP) {
            filterConditions.standard = '2'
          } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
            filterConditions.standard = '0'
          }
          this.$engine.services.payments.update(
            this.direction,
            this.paginationObject['maxResults'],
            this.paginationObject['firstIndex'],
            filterConditions
          ).then(resp => {
            let requests = {}
            switch (that.serviceId) {
              case services.PAYMENTS:
                that.requestsNumber = resp.data.totalPayments
                requests = resp.data.payments
                break
              default:
                break
            }
            that.paginationObject.nbResults = that.requestsNumber

            if (requests.length > 0) {
              for (let i = 0; i < requests.length; i++) {
                that.inboxMessages.push(requests[i])
              }
              if (requests.length < this.paginationObject['maxResults']) {
                that.detachInfinit()
              }
            } else {
              that.detachInfinit()
            }
            that.scrollFlag = true
          })
          .catch(error => {
            errorMessageAlert(error, that, that.$i18n)
            that.scrollFlag = true
          })
        }
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      // const that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      if (this.mode === 2 && this.serviceId !== services.DOCUMENTSERVICE) {
        if (this.serviceId === services.PAYMENTS) {
          this.activateSpinnerGroup = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          let filterConditions
          if (this.$engine.services.payments.filterGroup.getDefaultFilter()) {
            filterConditions = this.$engine.services.payments.filterGroup.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services.payments.filterGroup.getConditionObject()
          }
          this.getRTPGroup(filterConditions)
        }
      } else {
        let filterConditions
        if (Object.keys(this.filterConditions).length) {
          filterConditions = this.filterConditions
        } else {
          if (this.$engine.services.payments.filter.getDefaultFilter()) {
            filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services.payments.filter.getConditionObject()
          }
        }

        if (this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '1'
        } else if (!this.canSeeSRTP && this.canSeeHRTP) {
          filterConditions.standard = '2'
        } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
          filterConditions.standard = '0'
        }

        if (this.serviceId === services.PAYMENTS &&
          this.$engine.services.payments.currentSendbox.IdGroup) {
          filterConditions.IdGroup = this.$engine.services.payments.currentSendbox.IdGroup
          this.$engine.services.payments.currentSendbox = {}
        }
        this.$engine.services.payments.update(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          that.$engine.services.payments.updateLastRefresh()
          if (that._isDestroyed) {
            return
          }
          let requests = {}
          that.paginationObject.nbResultsTotal = resp.data.totalPayments
          that.paginationObject.nbResults = resp.data.payments.length
          that.payments = resp.data.payments

          that.updateItems(this.payments)

          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
          that.activateSpinner = false
        })
        .catch(error => {
          that.activateSpinner = false
          errorMessageAlert(error, that, that.$i18n)
        })
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    seeDetails (request) {
      this.keyTableRTP = !this.keyTableRTP
      request = request[0]
      this.$engine.services.payments.idRequest = request.id
      this.$engine.services.payments.office = 'front'
      loadPage(this, { url: '/payments/transaction-details/' + request.id})
    },
    seeDetails_grp (items_grp) {
      this.keyTableGroupRTP = !this.keyTableGroupRTP
      let message = items_grp[0].details_grp
      let that = this
      let redirectionUrl = {
        '1': '/payments/transaction-details/'
      }
      if (message.GroupIdentifier) {
        let filterConditions
        if (this.$engine.services.payments.filter.getDefaultFilter()) {
          filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
        } else {
          filterConditions = this.$engine.services.payments.filter.getConditionObject()
        }
        filterConditions.IdGroup = message.IdGroup
        this.$engine.settings.set({
          clickedMessage: {
            IdGroup: message.IdGroup,
            direction: '1'
          }
        })
        this.$engine.services.payments.update(
          2,
          1000,
          1,
          filterConditions
        ).then(resp => {
          let requests = resp.data.payments
          that.$bus.$emit('load-message', requests[0])
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
        loadPage(that, {
          url: redirectionUrl[this.serviceId]
        })
      } else {
        this.$engine.settings.set({
          clickedMessage: message
        })
        this.$bus.$emit('load-message', message)
        loadPage(that, {
          url: redirectionUrl[this.serviceId]
        })
      }

      // this.$f7.mainView.router.refreshPage()
      if (message.isRead && message.isRead !== '1' && this.serviceId !== '7' && this.serviceId !== '8') {
        this.updateToSeen(message.id)
      }
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {
        let rsn = ''
        rsn = requests[i].reason === '' ? '-' : requests[i].reason

        let status_label
        if (status === '1' && requests[i].direction === '0') {
          status_label = 'received_request'
        } else if (status === '1' && requests[i].direction === '1') {
          status_label = 'issued_request'
        } else {
          status_label = this.$i18n.t('common.status.rtp.' + requests[i].status)
          if (status_label === ('common.status.rtp.' + requests[i].status)) {
            status_label = 'unknown'
          } else {
            status_label = 'rtp.' + requests[i].status
          }
        }

        let amnt = ''
        if ((requests[i].direction === '1' && !requests[i].creditNoteAmount) ||
        (requests[i].Amount && parseFloat(requests[i].Amount) >= 0)
        || (requests[i].direction === '0' && requests[i].creditNoteAmount)) {
          amnt = '+ '
        } else {
          amnt = '- '
        }

        if (requests[i].creditNoteAmount) {
          amnt += parseFloat(requests[i].creditNoteAmount).toFixed(2).toString()
        } else {
          if (requests[i].amountResponse) {
            amnt += parseFloat(requests[i].amountResponse).toFixed(2).toString()
          } else if (requests[i].Amount) {
            amnt += parseFloat(requests[i].Amount.replace('-', '')).toFixed(2).toString()
          } else {
            amnt += parseFloat(requests[i].amount).toFixed(2).toString()
          }
        }

        switch (requests[i].currency) {
          case 'EUR':
            amnt += ' €'
            break
          case 'HUF':
            amnt += ' Ft'
            break
          case 'USD':
            amnt += ' $'
            break
          default:
            amnt += requests[i].currency
            break
        }

        let debtor_name = ''
        if (requests[i].debtorName === undefined || requests[i].debtorName === '') {
          debtor_name = '-'
        } else if (requests[i].direction === '1') {
          debtor_name = requests[i].debtorName
        } else {
          debtor_name = requests[i].creditorName
        }

        let debtor_iban = requests[i].debtorBankAccount


        // before we were using execution date (payment date)
        let exec_date = ''
        if (requests[i].acceptedRequestedExecutionDatetime) {
          exec_date = requests[i].acceptedRequestedExecutionDatetime
        } else if (requests[i].requestedExecutionDate) {
          exec_date = requests[i].requestedExecutionDate
        }

        let pastExecDate = false
        if (execDate && moment(exec_date) < moment() && ['9','10'].includes(requests[i].status) && requests[i].direction === '0') {
          pastExecDate = true
        }

        let create_date = requests[i].creationDate

        let exp_date = ''
        if(requests[i].requestedExpirationDate) {
          exp_date = requests[i].requestedExpirationDate
        }

        let direction = ''
        if(requests[i].direction) {
          if(requests[i].direction === '0') {
            direction = 0
          } else {
            direction = 1
          }
        }

        let standard = ''
        if(requests[i].standard) {
          standard = requests[i].standard
        }

        let result = {
          id: requests[i].id,
          rsn: rsn,
          status_label: status_label,
          amnt: amnt,
          debtor_name: debtor_name,
          debtor_iban: debtor_iban,
          create_date: create_date,
          exp_date: exp_date,
          exec_date_warning: pastExecDate,
          direction: direction,
          standard: standard
        }
        this.items.push(result)
      }
    },
    updateItems_grp (requests) {
      this.items_grp = []
      for (var i = 0; i < requests.length; i++) {
        let rsn_grp = requests[i].Name

        let status_label_grp = statusLabel(this.$i18n, 'PaymentGroup_' + requests[i].Status, requests[i].negotStatus, requests[i].direction)

        let amnt_grp = ''
        if (requests[i].direction === '1' ||
          (requests[i].Amount && parseFloat(requests[i].Amount) >= 0)) {
          amnt_grp = '+ '
        } else {
          amnt_grp = '- '
        }

        let dir_pymnts_grp = requests[i].TotalPayments + ' paiements'

        if (requests[i].amountResponse) {
          amnt_grp += parseFloat(requests[i].amountResponse).toFixed(2).toString()
        } else if (requests[i].Amount) {
          amnt_grp += parseFloat(requests[i].Amount.replace('-', '')).toFixed(2).toString()
        } else {
          amnt_grp += parseFloat(requests[i].amount).toFixed(2).toString()
        }

        amnt_grp += ' €'

        let exec_date_grp = ''
        if (requests[i].executionDateResponse) {
          exec_date_grp = requests[i].executionDateResponse
        } else if (requests[i].date) {
          exec_date_grp = requests[i].date
        } else if (requests[i].requestedExecutionDate) {
          exec_date_grp = requests[i].requestedExecutionDate
        } else if (requests[i].Date) {
          exec_date_grp = requests[i].Date
        } else {
          exec_date_grp = requests[i].creationDate
        }

        if (exec_date_grp !== '') {
          exec_date_grp = moment(exec_date_grp).format('DD/MM/YYYY')
        }

        let result = {
          rsn_grp: rsn_grp,
          status_label_grp: status_label_grp,
          amnt_grp: amnt_grp,
          dir_pymnts_grp: dir_pymnts_grp,
          exec_date_grp: exec_date_grp,
          details_grp: requests[i]
        }
        this.items_grp.push(result)
      }
    }
  }
}
</script>
